import React, { PropsWithChildren } from 'react';

import { utilities } from '~/common';

import { IconGroupWrapper, IconWrapper, Button } from './elements';
import { IconLink, IconPrint, IconSocialFacebook, IconSocialTwitter } from '../icons';

interface Props {
  title: string;
  full_url: string;
  url_title?: string;
  hidePrintButton?: boolean;
}

const { getFbAndTwitterShareLinks } = utilities;

export const ShareIconsGroup: React.FC<PropsWithChildren<Props>> = ({
  title,
  full_url,
  url_title,
  hidePrintButton,
}) => {
  const { facebookLink, twitterLink } = getFbAndTwitterShareLinks({ full_url, title });
  return (
    <IconGroupWrapper kind="articles">
      <a
        className="social-share"
        data-platform-name="Facebook"
        data-media-title={title}
        href={facebookLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
      >
        <IconWrapper className="icon-wrapper">
          <IconSocialFacebook />
        </IconWrapper>
      </a>

      <a
        className="social-share"
        data-platform-name="Twitter"
        data-media-title="{title}"
        href={twitterLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Twitter"
      >
        <IconWrapper className="icon-wrapper">
          <IconSocialTwitter />
        </IconWrapper>
      </a>

      <Button onClick={() => navigator.clipboard.writeText(full_url)} aria-label="Copy link">
        <IconWrapper className="icon-wrapper">
          <IconLink />
        </IconWrapper>
      </Button>

      {!hidePrintButton && (
        <a
          className="social-share print-article"
          data-platform-name="Print"
          data-media-title={title}
          data-article-id={url_title}
          href="javascript:void(0)"
          onClick={() => window.print()}
          aria-label="Print"
        >
          <IconWrapper className="icon-wrapper">
            <IconPrint />
          </IconWrapper>
        </a>
      )}
    </IconGroupWrapper>
  );
};
